import { ApiFuncParam } from '@/modules'

export function buildUrlRequest(url: string, urlParams?: ApiFuncParam | string): string {
  if (!url || !urlParams) return url
  let finalUrl = url
  const queryParams: ApiFuncParam = {}
  if (typeof urlParams === 'object') {
    const params = { ...urlParams }
    finalUrl = finalUrl.replace(/:([a-zA-Z0-9_]+)/g, (match, p) => {
      if (Object.prototype.hasOwnProperty.call(params, p)) {
        const value = params[p]
        delete params[p]
        return encodeURIComponent(String(value))
      }
      return match
    })
    Object.assign(queryParams, params)
  }

  const queryString = buildUrlParams(urlParams)
  return queryString ? `${finalUrl}${queryString}` : finalUrl
}

function buildUrlParams(urlParams?: ApiFuncParam | string): string | undefined {
  if (!urlParams) return undefined

  if (typeof urlParams === 'string') return urlParams

  if (typeof urlParams === 'object') {
    const searchParams = new URLSearchParams()
    Object.entries(urlParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, String(value))
      }
    })
    return `?${searchParams.toString()}`
  }
  return undefined
}
